import React from 'react';
import { useNavigate } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditHomeSection from '../../components/home_sections/FormAddEditHomeSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import { useTranslation } from 'react-i18next';

const CreateHomeSection = () => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const navigate = useNavigate();

    const onSubmitSuccess = () => {
        navigate('/home-sections');
    };

    const links = [
        { label: isArabic ? 'الرئيسية' : 'Home', path: '/' },
        { label: isArabic ? 'أقسام الصفحة الرئيسية' : 'Home Sections', path: '/home-sections' },
        { label: isArabic ? 'إضافة قسم جديد' : 'Add New Section', path: '/home-sections/create', active: true },
    ];

    return (
        <WrapperSection>
            <GlobalBreadcrumbs links={links} />
            <FormAddEditHomeSection onSubmitSuccess={onSubmitSuccess} />
        </WrapperSection>
    );
};

export default CreateHomeSection;
